import { render, staticRenderFns } from "./enhancePromotMsgItem.vue?vue&type=template&id=a232a692&scoped=true"
import script from "./enhancePromotMsgItem.vue?vue&type=script&lang=js"
export * from "./enhancePromotMsgItem.vue?vue&type=script&lang=js"
import style0 from "./enhancePromotMsgItem.vue?vue&type=style&index=0&id=a232a692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a232a692",
  null
  
)

export default component.exports